import { ApiUserRole } from '@/enum/ApiUserRole'
import { TemplateMail } from '@/enum/TemplateMail'
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloUser,cleanAloUser,getDefaultAloUser } from './AloUser'


export interface AloSejour extends AloBase {
            
    usrId:number
    user: AloUser
    chambres:Array<string>
    sjrCheckIn: string
    sjrCheckOut: string
    sjrDateMail: string
    sjrDatadd: string
    sjrValide:boolean
    sjrTel: string
    sjrEnable:boolean
    mtpId:TemplateMail|null
}

export const getDefaultAloSejour = (role:ApiUserRole = ApiUserRole.Visiteur,chambre:string=""):AloSejour => {
    return {  
        ...getDefaultAloBase(),
        usrId:0,
        user : getDefaultAloUser(role),
        sjrValide:true,
        chambres : [chambre],
        sjrCheckIn: "",
        sjrCheckOut:"",
        sjrDatadd:"",
        sjrDateMail:"",
        sjrTel:"",
        sjrEnable:false,
        mtpId:null
    }
}


export const cleanAloSejour = (sejour:AloSejour) => {
    if(!sejour) return    
    if(!sejour.id) delete sejour.id    
    if(!sejour.mtpId) delete sejour.mtpId
    cleanAloUser(sejour.user)
}

